import { TimeEntry } from './TimeEntry'

export default TimeEntry
